import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Input,
  Col,
  Table,
  Spin,
  Button,
  Modal,
  type TableProps,
  DatePicker,
  Space,
  Select,
  Tooltip,
  Flex,
} from "antd";
import dayjs from 'dayjs';

import { CheckOutlined, ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, infoMessage, successMessage } from "../../../messages/messages";
import type { IAnularOperacaoRequisicao, IAlteracaoEfpc, IPessoaJuridica, IEfpc, IAutorizacaoPlano, IAlteracaoPlano, IOperacaoEfpc, IPlanoBeneficios, IAutorizacaoConvenio } from "../../../components/Interfaces";

import { disabledDate, isStateValid, onlyNumbers, pushToBase } from "../../../utils/utilsFunctions";
import { PatternFormat } from "react-number-format";
import api, { apiPlanosBeneficios, apiPrimarias } from "../../../services/api";
import { PageHeader } from "@ant-design/pro-components";
import TextArea from "antd/es/input/TextArea";
import { maskCnpj, numberOnly } from "../../../utils/maskFunctions";

const Operacoes: React.FC<any> = () => {

  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();

  const { confirm } = Modal;

  const [operacoesEfpc, setOperacoesEfpc] = useState<IOperacaoEfpc[]>([]);
  const [operacoesAlterarEfpc, setOperacoesAlterarEfpc] = useState<IAlteracaoEfpc[]>([]);
  const [operacoesAutorizacaoPlano, setOperacoesAutorizacaoPlano] = useState<IAutorizacaoPlano[]>([]);
  const [operacoesAlteracaoPlano, setOperacoesAlteracaoPlano] = useState<IAlteracaoPlano[]>([]);
  const [operacoesAutorizacaoConvenio, setOperacoesAutorizacaoConvenio] = useState<IAutorizacaoConvenio[]>([]);

  const [loading, setLoading] = useState(false);
  const [tipLoading, _setTipLoading] = useState("");

  const [pessoaJuridicaefpcRequerente, setPessoaJuridicaefpcRequerente] = useState<IPessoaJuridica>();
  const [pessoaJuridicaPlanoOperacaoAutorizar, setPessoaJuridicaPlanoOperacaoAutorizar] = useState<IPessoaJuridica>();
  const [efpcRequerente, setefpcRequerente] = useState<IEfpc>();
  const [operacaoSelecionada, setOperacaoSelecionada] = useState<IOperacaoEfpc>();

  const [planosEfpc, setPlanosEfpc] = useState<IPlanoBeneficios[]>([]);
  const [planoSelecionadoParaAlterarOuParaConvenio, setPlanoSelecionadoParaAlterarOuParaConvenio] = useState<IPlanoBeneficios>();

  const [pessoaJuridicaRequisicao, setPessoaJuridicaRequisicao] = useState<IPessoaJuridica>();

  const [operacaoSelectedRowKeys, setOperacaoSelectedRowKeys] = useState<React.Key[]>([]);
  const [modalAnulacaoAberto, setModalAnulacaoAberto] = useState(false);
  const [modalNovaRequisicaoAlteracaoEfpcAberto, setModalNovaRequisicaoAlteracaoEfpcAberto] = useState(false);
  const [modalNovaRequisicaoAlteracaoPlanoAberto, setModalNovaRequisicaoAlteracaoPlanoAberto] = useState(false);
  const [modalNovaRequisicaoAutorizacaoConvenioAberto, setModalNovaRequisicaoAutorizacaoConvenioAberto] = useState(false);

  const [tipoAcao, setTipoAcao] = useState(0); // 1: Alteração EFPC / 2: Autorização Plano / 3: Alteração Plano / 4: Autorização Convênio / 
  // 108: Cancelamento Operação Autorizar EFPC /  208: Anulação Operação Autorizar EFPC
  // 118: Cancelamento Operação Alterar EFPC /    218: Anulação Operação Alterar EFPC
  // 128: Cancelamento Operação Encerrar EFPC /   228: Anulação Operação Encerrar EFPC
  // 109: Cancelamento Operação Autorizar Plano / 209: Anulação Operação Autorizar Plano
  // 119: Cancelamento Operação Alterar Plano /   219: Anulação Operação Alterar Plano
  // 129: Cancelamento Operação Encerrar Plano /  229: Anulação Operação Encerrar Plano

  const [tipoRequisicao, setTipoRequisicao] = useState(0); // 1: Alteração EFPC / 2: Autorização Plano / 3: Alteração Plano / 4: Autorização Convênio

  const tpAlteracaoEfpc = "Requisição de Alteração Efpc";
  const tpAlteracaoPlano = "Requisição de Alteracao Plano de Benefícios";
  const tpAutorizacaoPlano = "Requisição de Autorização de Plano de Benefícios";
  const tpAutorizacaoConvenio = "Requisição de Autorização de Convênio de Adesão";

  useEffect(() => {
    window.scrollTo(0, 0)

    if (isStateValid(state)) {
      //console.log(state);
      validarefpcRequerente(state.data);
    } else {
      errorMessage("Não foi possível identificar as operações da Entidade.");
      pushToBase(navigate);
    }
  }, []);

  useEffect(() => {
    if (planosEfpc.length > 0 && tipoRequisicao === 3) // REQUISIÇÃO DE ALTERAÇÃO DE PLANO
      setModalNovaRequisicaoAlteracaoPlanoAberto(true);
    if (planosEfpc.length > 0 && tipoRequisicao === 4) // REQUISIÇÃO DE AUTORIZAÇÃO DE CONVÊNIO DE ADESÃO
      setModalNovaRequisicaoAutorizacaoConvenioAberto(true);
  }, [planosEfpc, tipoRequisicao]);

  useEffect(() => {
    if (!modalNovaRequisicaoAutorizacaoConvenioAberto) {
      limpaModal();
    }
  }, [modalNovaRequisicaoAutorizacaoConvenioAberto]);


  useEffect(() => {
    if (pessoaJuridicaRequisicao) {
      form.setFieldsValue({
        razaoSocialPessoaJuridicaConvenio: pessoaJuridicaRequisicao.razaoSocial,
      });
    }
  }, [pessoaJuridicaRequisicao]);

  useEffect(() => {
    setOperacoesEfpc(toOperacaoEfpcArray(operacoesAlterarEfpc, operacoesAlteracaoPlano, operacoesAutorizacaoPlano, operacoesAutorizacaoConvenio));
  }, [operacoesAlterarEfpc, operacoesAutorizacaoPlano, operacoesAlteracaoPlano, operacoesAutorizacaoConvenio]);

  useEffect(() => {
    if (pessoaJuridicaefpcRequerente) {
      form.setFieldsValue({
        operacaoRazaoSocial: pessoaJuridicaefpcRequerente.razaoSocial,
        operacaoCnpjEfpc: pessoaJuridicaefpcRequerente.tipoIdentificador === 1 ? pessoaJuridicaefpcRequerente.numero : undefined,
        operacaoNumeroProcessoEfpc: pessoaJuridicaefpcRequerente.tipoIdentificador === 3 ? onlyNumbers(pessoaJuridicaefpcRequerente.numero) : undefined,
      });
    }
  }, [pessoaJuridicaefpcRequerente]);

  useEffect(() => {
    if (tipoAcao > 0) {
      mostrarConfirmar(tipoAcao);
    }
  }, [tipoAcao]);

  useEffect(() => {
    if (efpcRequerente) {
      if (efpcRequerente.serie) {
        getOperacaoAlteracaoEfpcPorSerieEfpc(efpcRequerente.serie);
        getOperacaoAutorizacaoPlanoPorSerieEfpc(efpcRequerente.serie);
        getOperacaoAlteracaoPlanoPorSerieEfpc(efpcRequerente.serie);
        getOperacaoAutorizacaoConvenioPorSerieEfpc(efpcRequerente.serie);
      }
      setPessoaJuridicaefpcRequerente(efpcRequerente.pessoaJuridicaEfpc);
      form.setFieldsValue({
        operacaoSigla: efpcRequerente.sigla,
      });
    }
  }, [efpcRequerente]);

  useEffect(() => {
    if (operacaoSelecionada) {
      setPessoaJuridicaPlanoOperacaoAutorizar(operacaoSelecionada.pessoaJuridicaObjeto);
    }
  }, [operacaoSelecionada]);

  const limpaModal = () => {
    setPlanoSelecionadoParaAlterarOuParaConvenio(undefined);
    setPessoaJuridicaRequisicao(undefined);
    form.setFieldsValue({
      razaoSocialPessoaJuridicaConvenio: undefined,
      cnpjNumeroAutConvenio: undefined,
      numeroIdentificacaoFiscalAutConvenio: undefined,
      siglaPlanoAutorizacaoConvenio: undefined,
      dataPosicaoRequisicaoAutConvenio: undefined,
    });
  };

  function mapToOperacao<T extends {
    id?: string;
    serie?: number;
    numero?: string;
    serieEfpc: number;
    dataPosicao: string;
    pessoaJuridicaObjeto?: IPessoaJuridica;
    requerente?: IEfpc;
    objeto?: IPlanoBeneficios;
    situacao?: number
  }>(
    arr: T[],
    tipo: string
  ): IOperacaoEfpc[] {
    return arr.map(o => ({
      id: o.id,
      serie: o.serie,
      tipoInterface: tipo,
      numero: o.numero,
      serieEfpc: o.serieEfpc,
      dataPosicao: o.dataPosicao,
      pessoaJuridicaObjeto: o.pessoaJuridicaObjeto,
      requerente: o.requerente,
      objeto: o.objeto,
      situacao: o.situacao
    }));
  }

  function toOperacaoEfpcArray(
    alteracaoEfpc: IAlteracaoEfpc[],
    alteracaoPlano: IAlteracaoPlano[],
    autorizacaoPlano: IAutorizacaoPlano[],
    autorizacaoConvenio: IAutorizacaoConvenio[]
  ): IOperacaoEfpc[] {

    return [
      ...mapToOperacao(alteracaoEfpc, tpAlteracaoEfpc),
      ...mapToOperacao(alteracaoPlano, tpAlteracaoPlano),
      ...mapToOperacao(autorizacaoPlano, tpAutorizacaoPlano),
      ...mapToOperacao(autorizacaoConvenio, tpAutorizacaoConvenio)
    ];
  }


  function validarefpcRequerente(efpcReq: IEfpc) {
    if (!efpcReq || !efpcReq.serie || efpcReq.serie <= 0) {
      errorMessage("Não foi possível identificar a Entidade Requerente");
      pushToBase(navigate);
    } else {
      setefpcRequerente(efpcReq);
    }
  }

  const getPlanosPorPorSerieEfpc = async (numero: string) => {
    try {
      setLoading(true);
      let lQuery = `/ultimo/${numero}/matricula`;
      const { data } = await apiPlanosBeneficios.get(lQuery);
      if (data.length === 0) {
        infoMessage("Não foram identificados Planos de Benefícios vinculados à Entidade requisitante.");
      } else
        setPlanosEfpc(data);
    } catch (error) {
      //console.log(error);
      errorMessage("Erro ao tentar localizar os Planos de Benefícios vinculados à Entidade requisitante.");
    } finally {
      setLoading(false);
    }
  };

  const getPessoaJuridica = async () => {
    const currentForm = form.getFieldsValue();

    if (currentForm.cnpjNumeroAutConvenio && currentForm.cnpjNumeroAutConvenio !== ""
      && currentForm.numeroIdentificacaoFiscalAutConvenio && currentForm.numeroIdentificacaoFiscalAutConvenio !== "") {
      errorMessage("Preencha apenas uma opção para pesquisa de Pessoa Jurídica");
      return;
    }

    if ((!currentForm.cnpjNumeroAutConvenio || currentForm.cnpjNumeroAutConvenio === "")
      &&
      (!currentForm.numeroIdentificacaoFiscalAutConvenio || currentForm.numeroIdentificacaoFiscalAutConvenio === "")) {
      errorMessage("Preencha uma opção para pesquisa de Pessoa Jurídica");
      return;
    }

    try {
      setLoading(true);

      const numero = currentForm?.cnpjNumeroAutConvenio && currentForm?.cnpjNumeroAutConvenio !== "" ? numberOnly(currentForm?.cnpjNumeroAutConvenio) : (currentForm?.numeroIdentificacaoFiscalAutConvenio ? numberOnly(currentForm?.numeroIdentificacaoFiscalAutConvenio) : "")

      let lQuery = `consulta/dinamica?numero=${numero}&page-size=10&page=0`;

      await api.get(lQuery).then((response) => {
        //console.log(response);
        if (response.data.content.length === 0) {
          infoMessage("O sistema não encontrou resultado para consulta realizada");
        } else if (response.data.content.length > 1) {
          errorMessage("O sistema não encontrou mais de uma Pessoa Jurídica para consulta realizada");
        } else {
          setPessoaJuridicaRequisicao(response.data.content[0]);
        }
      })

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta. " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getOperacaoAlteracaoEfpcPorSerieEfpc = async (serie: number) => {
    try {
      setLoading(true);

      let lQuery = `/efpc/alteracao/${serie}/serie/todas`;
      const { data } = await apiPrimarias.get(lQuery);
      //console.log(data);
      setOperacoesAlterarEfpc(data);
      setOperacaoSelecionada(undefined);
    } catch (error) {
      //console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };

  const getOperacaoAutorizacaoConvenioPorSerieEfpc = async (serie: number) => {
    try {
      setLoading(true);

      let lQuery = `/convenio/convenio/${serie}/serie/todas`;
      const { data } = await apiPrimarias.get(lQuery);
      //console.log(data);
      setOperacoesAutorizacaoConvenio(data);
      setOperacaoSelecionada(undefined);
    } catch (error) {
      //console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };


  const getOperacaoAutorizacaoPlanoPorSerieEfpc = async (serie: number) => {
    try {
      setLoading(true);

      let lQuery = `/plano-de-beneficios/autorizacao/${serie}/serie/todas`;
      const { data } = await apiPrimarias.get(lQuery);
      //console.log(data);
      setOperacoesAutorizacaoPlano(data);
      setOperacaoSelecionada(undefined);
    } catch (error) {
      //console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };

  const getOperacaoAlteracaoPlanoPorSerieEfpc = async (serie: number) => {
    //console.log("aqui")
    try {
      setLoading(true);

      let lQuery = `/plano-de-beneficios/alteracao/${serie}/serie/todas`;
      const { data } = await apiPrimarias.get(lQuery);
      //console.log(data);
      setOperacoesAlteracaoPlano(data);
      setOperacaoSelecionada(undefined);
    } catch (error) {
      //console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };

  function pushToEfpcAlterar() {
    let tpSelecao = {
      data: operacaoSelecionada,
      dataEfpcRequerente: efpcRequerente,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/efpc-alterar", { state: tpSelecao });
  }

  function pushToPlanoCadastrar() {
    let tpSelecao = {
      data: operacaoSelecionada,
      dataEfpcRequerente: efpcRequerente,
      dataPessoaJuridicaPlano: pessoaJuridicaPlanoOperacaoAutorizar,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/plano-cadastrar", { state: tpSelecao });
  }

  function pushToPlanoAlterar() {
    let tpSelecao = {
      data: operacaoSelecionada,
      dataEfpcRequerente: efpcRequerente,
      dataPlano: operacaoSelecionada?.objeto,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/plano-alterar", { state: tpSelecao });
  }

  function pushToNovaOperacaoAutorizarPlano() {
    let tpSelecao = {
      data: efpcRequerente,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/efpc-operacao-autorizacao-plano", { state: tpSelecao });
  }

  function pushToConvenioCadastrar() {

    let tpSelecao = {
      data: operacaoSelecionada,
      dataEfpcRequerente: efpcRequerente,
      dataPessoaJuridicaPatrocinador: operacaoSelecionada?.patrocinador,
      dataPlanoObjeto: operacaoSelecionada?.objeto,
    };
    //console.log(tpSelecao);

    navigate("/" + import.meta.env.VITE_APP_BASE + "/convenio-cadastrar", { state: tpSelecao });
  }


  function gerarColunasOperacoes() {
    let cols: any[] = [];

    cols.push({
      title: "Operação",
      dataIndex: "tipoInterface",
    });

    cols.push({
      width: 100,
      title: "Número",
      dataIndex: "numero",
    });

    cols.push({
      width: 100,
      title: "Série",
      dataIndex: "serie",
    });

    cols.push({
      width: 150,
      title: "Nome",
      dataIndex: "nmOperacao",
    });

    cols.push({
      width: 150,
      title: "Situação",
      dataIndex: "",
      render: (aut: IAlteracaoEfpc) => (
        <>
          {aut.situacao && aut.situacao === 3 ? "Anulada" : aut.situacao === 2 ? "Cancelada" : aut.situacao === 1 ? "Aprovada" : ""}
        </>
      ),
    });

    cols.push({
      width: 150,
      title: "Objeto da Operação",
      dataIndex: "",
      render: (aut: IAlteracaoEfpc) => (
        <>
          {aut.tipoInterface === tpAlteracaoEfpc ? aut.requerente?.sigla.toUpperCase() : aut.tipoInterface === tpAutorizacaoPlano ? aut.pessoaJuridicaObjeto?.razaoSocial?.toUpperCase() : aut.objeto?.sigla.toUpperCase()}
        </>
      ),
    });

    cols.push({
      width: 150,
      title: "Data Posição",
      dataIndex: "",
      render: (aut: IAlteracaoEfpc) => (
        <>
          {aut.dataPosicao && aut.dataPosicao !== "" ? dayjs(aut.dataPosicao).format("DD/MM/YYYY") : ""}
        </>
      ),
    });

    return cols.filter(Boolean);
  }

  const columnsOperacoes = gerarColunasOperacoes();

  function mostrarConfirmar(tipo: number) {

    confirm({
      title:
        tipo === 1
          ? "Deseja aprovar a Operação e efetuar a Alteração da Entidade?"
          :
          tipo === 2
            ? "Deseja aprovar a Operação e efetuar o Cadastro do Plano de Benefício?"
            :
            tipo === 3
              ? "Deseja aprovar a Operação e Efetuar a Alteração do Plano de Benefício?"
              :
              tipo === 4
                ? "Deseja aprovar a Operação e Efetuar o Cadastro do Convênio de Adesão?"
                :
                tipo === 8
                  ? "Deseja Cancelar a Operação?"
                  :
                  tipo === 9
                    ? "Deseja Anular a Operação?"
                    : "Erro",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: (tipo === 3 ? "Plano: " + operacaoSelecionada?.objeto?.nome : (tipo === 4 ? "Convênio: " + operacaoSelecionada?.objeto?.nome : "Entidade: " + efpcRequerente?.sigla)) + ". Operação: " + operacaoSelecionada?.numero,
      okButtonProps: { id: 'ok' },
      onOk() {
        form.validateFields();
        window.scrollTo(0, 0)
        form.submit();
      },
      onCancel() { setTipoAcao(0) },
    });

  }

  const operacaoRowSelection: TableProps<IAlteracaoEfpc>['rowSelection'] = {
    type: "radio", // ensures only one row selected
    selectedRowKeys: operacaoSelectedRowKeys,
    onChange: (newSelectedKeys, selectedRows: IAlteracaoEfpc[]) => {
      if (selectedRows[0].situacao === 3) {
        infoMessage("Operação já anulada");
      } else if (selectedRows[0].situacao === 2) {
        infoMessage("Operação já cancelada");
      } else {
        setOperacaoSelectedRowKeys(newSelectedKeys);
        setOperacaoSelecionada(selectedRows[0]); // store selected object
      }
    },
  };


  const efpcAlteracaoRequerer = async () => {
    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
      errorMessage("Não foi possível identificar a série da Entidade para a requerer a Operação de Alteração de Entidade.");
      return
    }
    setLoading(true);
    const currentForm = form.getFieldsValue();

    const jsonRequisicao: IAlteracaoEfpc =
    {
      serieEfpc: efpcRequerente?.serie || 0,
      dataPosicao: currentForm.dataPosicaoRequisicaoAltEfpc ? dayjs(currentForm.dataPosicaoRequisicaoAltEfpc).format('YYYY-MM-DDTHH:mm:ss') : "",
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/efpc/alteracao/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      successMessage(
        `Operação de Alteração número ${data.numero} criada com Sucesso.`
      );

      getOperacaoAlteracaoEfpcPorSerieEfpc(efpcRequerente?.serie || 0);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    } finally {
      setModalNovaRequisicaoAlteracaoEfpcAberto(false);
      setLoading(false);
    }
  };

  const planoAlteracaoRequerer = async () => {
    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
      errorMessage("Não foi possível identificar a série da Entidade para a requerer a Operação de Alteração de Plano.");
      return
    }

    if (!planoSelecionadoParaAlterarOuParaConvenio || !planoSelecionadoParaAlterarOuParaConvenio.serie || planoSelecionadoParaAlterarOuParaConvenio.serie <= 0) {
      errorMessage("Não foi possível identificar a série do Plano de Benefícios para a requerer a Operação de Alteração de Plano.");
      return
    }

    setLoading(true);
    const currentForm = form.getFieldsValue();

    const jsonRequisicao: IAlteracaoPlano =
    {
      serieEfpc: efpcRequerente?.serie || 0,
      serie: planoSelecionadoParaAlterarOuParaConvenio?.serie || 0,
      numero: planoSelecionadoParaAlterarOuParaConvenio?.numero || "",
      dataPosicao: currentForm.dataPosicaoRequisicaoAltPlano ? dayjs(currentForm.dataPosicaoRequisicaoAltPlano).format('YYYY-MM-DDTHH:mm:ss') : "",
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/plano-de-beneficios/alteracao/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      successMessage(
        `Operação de Alteração número ${data.numero} criada com Sucesso.`
      );

      getOperacaoAlteracaoEfpcPorSerieEfpc(efpcRequerente?.serie || 0);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
    } finally {
      setModalNovaRequisicaoAlteracaoPlanoAberto(false);
      setLoading(false);
    }
  };

  const convenioAutorizacaoRequerer = async () => {
    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
      errorMessage("Não foi possível identificar a série da Entidade para a requerer a Operação de Autorização de Convênio de Adesão.");
      return
    }

    if (!planoSelecionadoParaAlterarOuParaConvenio || !planoSelecionadoParaAlterarOuParaConvenio.serie || planoSelecionadoParaAlterarOuParaConvenio.serie <= 0) {
      errorMessage("Não foi possível identificar a série do Plano de Benefícios para a requerer a Operação de Autorização de Convênio de Adesão.");
      return
    }

    if (!pessoaJuridicaRequisicao || !pessoaJuridicaRequisicao.serie || pessoaJuridicaRequisicao.serie <= 0) {
      errorMessage("Não foi possível identificar a série da Pessoa Jurídica para requerer a Operação de Autorização de Convênio de Adesão.");
      return
    }

    setLoading(true);
    const currentForm = form.getFieldsValue();

    const jsonRequisicao: IAutorizacaoConvenio =
    {
      serieEfpc: efpcRequerente?.serie || 0,
      seriePlano: planoSelecionadoParaAlterarOuParaConvenio?.serie || 0,
      seriePessoaJuridica: pessoaJuridicaRequisicao?.serie || 0,
      dataPosicao: currentForm.dataPosicaoRequisicaoAutConvenio ? dayjs(currentForm.dataPosicaoRequisicaoAutConvenio).format('YYYY-MM-DDTHH:mm:ss') : "",
    }

    try {
      let query = `/convenio/convenio/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      successMessage(
        `Operação de Autorizaçao de Convênio número ${data.numero} criada com Sucesso.`
      );

      getOperacaoAutorizacaoConvenioPorSerieEfpc(efpcRequerente?.serie || 0);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
    } finally {
      setModalNovaRequisicaoAutorizacaoConvenioAberto(false);
      setLoading(false);
    }
  };

  const cancelarOperacao = async (numero: string, tpAcao: number) => {

    if (numero === "") return;

    setLoading(true);

    try {
      const query = (): string => {
        switch (tpAcao) {
          case 108:
            return `/efpc/autorizacao/cancelar/${numero}`;
          case 118:
            return `/efpc/alteracao/cancelar/${numero}`;
          case 128:
            return `/efpc/encerramento/cancelar/${numero}`;
          case 109:
            return `/plano-de-beneficios/autorizacao/cancelar/${numero}`;
          case 119:
            return `/plano-de-beneficios/alteracao/cancelar/${numero}`;
          case 129:
            return `/plano-de-beneficios/encerramento/cancelar/${numero}`;
          default:
            return "";
        }
      };

      await apiPrimarias.post(query.toString());
      setLoading(false);

      successMessage("Operação Cancelada com sucesso.");
      getOperacaoAlteracaoEfpcPorSerieEfpc(efpcRequerente?.serie || 0);
      //console.log(data);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    } finally {
      setLoading(false);
    }
  };


  const anularOperacao = async (numero: string, tpAcao: number) => {
    setLoading(true);
    const currentForm = form.getFieldsValue();

    const json: IAnularOperacaoRequisicao =
    {
      justificativa: currentForm.justificativaAnulacao,
    }

    try {
      const query = (): string => {
        switch (tpAcao) {
          case 208:
            return `/efpc/autorizacao/anular/${numero}`;
          case 218:
            return `/efpc/alteracao/anular/${numero}`;
          case 228:
            return `/efpc/encerramento/anular/${numero}`;
          case 209:
            return `/plano-de-beneficios/autorizacao/anular/${numero}`;
          case 219:
            return `/plano-de-beneficios/alteracao/anular/${numero}`;
          case 229:
            return `/plano-de-beneficios/encerramento/anular/${numero}`;
          default:
            return "";
        }
      };


      await apiPrimarias.post(query.toString(), json);
      setLoading(false);

      successMessage("Operação Anulada com sucesso.");
      getOperacaoAlteracaoEfpcPorSerieEfpc(efpcRequerente?.serie || 0);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    } finally {
      setModalAnulacaoAberto(false);
    }
  };



  function identificarAcao() {
    if (tipoAcao === 1) {
      pushToEfpcAlterar();
    } else if (tipoAcao === 2) {
      pushToPlanoCadastrar();
    } else if (tipoAcao === 3) {
      pushToPlanoAlterar();
    } else if (tipoAcao === 4) {
      pushToConvenioCadastrar();
    } else if (tipoAcao > 100 && tipoAcao < 200) {
      cancelarOperacao(operacaoSelecionada?.numero || "", tipoAcao);
    } else if (tipoAcao > 200) {
      anularOperacao(operacaoSelecionada?.numero || "", tipoAcao);
    }
  }

  const handlePlanoSelecionado = async (plano: any) => {
    form.setFieldsValue({
      siglaPlanoAlteracao: plano.label,
    });
    setPlanoSelecionadoParaAlterarOuParaConvenio(planosEfpc.find(l => l.serie == plano.key));
  };

  return (
    <Spin spinning={loading} tip={tipLoading}>
      <Modal title="Requisição de Operação de Alteração de Entidade"
        destroyOnHidden={true}
        open={modalNovaRequisicaoAlteracaoEfpcAberto}
        onOk={() => {
          if (efpcRequerente?.numero) {
            efpcAlteracaoRequerer();
          }
          else
            errorMessage("Número da Entidade não localizado.");

        }}
        onCancel={() => setModalNovaRequisicaoAlteracaoEfpcAberto(false)}
      >
        <Form layout="vertical" form={form}>
          <p>Requisitante: {efpcRequerente?.sigla} </p>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Data Posição"
                name="dataPosicaoRequisicaoAltEfpc"
                rules={[
                  {
                    required: true,
                    message: "Data posição não preenchida",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="Requisição de Operação de Alteração de Plano de Benefícios"
        destroyOnHidden={true}
        open={modalNovaRequisicaoAlteracaoPlanoAberto}
        onOk={() => {
          if (efpcRequerente?.numero) {
            planoAlteracaoRequerer();
          }
          else
            errorMessage("Número da Entidade não localizado.");
        }}
        onCancel={() => setModalNovaRequisicaoAlteracaoPlanoAberto(false)}
      >
        <Form layout="vertical" form={form}>
          <p>Requisitante: {efpcRequerente?.sigla} </p>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Data Posição"
                name="dataPosicaoRequisicaoAltPlano"
                rules={[
                  {
                    required: true,
                    message: "Preencha a Data de Posição",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <Form.Item label="Plano de Benefícios"
                labelAlign="left"
                labelCol={{ span: 20 }}
                name="siglaPlanoAlteracao"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Selecione o Plano de Benefícios para Alteração",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Planos de Benefícios'
                  onChange={(_, index) => {
                    handlePlanoSelecionado(index);
                  }}
                >
                  {planosEfpc.map((e: IPlanoBeneficios) => (
                    <Select.Option key={e.serie} value={e.nome}>
                      {e.nome}
                    </Select.Option>
                  ))}
                </Select>

              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="Requisição de Operação de Autorização de Convênio de Adesão"
        destroyOnHidden={true}
        open={modalNovaRequisicaoAutorizacaoConvenioAberto}
        onOk={() => {
          if (efpcRequerente?.numero) {
            convenioAutorizacaoRequerer();
          }
          else
            errorMessage("Número da Entidade não localizado.");
        }}
        onCancel={() => setModalNovaRequisicaoAutorizacaoConvenioAberto(false)}
      >
        <Form layout="vertical" form={form}>
          <p>Requisitante: {efpcRequerente?.sigla} </p>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Data Posição"
                name="dataPosicaoRequisicaoAutConvenio"
                rules={[
                  {
                    required: true,
                    message: "Preencha a Data de Posição",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <Form.Item label="Plano de Benefícios"
                labelAlign="left"
                labelCol={{ span: 20 }}
                name="siglaPlanoAutorizacaoConvenio"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Selecione o Plano de Benefícios para o Convênio de Adesão",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Planos de Benefícios'
                  onChange={(_, index) => {
                    handlePlanoSelecionado(index);
                  }}
                >
                  {planosEfpc.map((e: IPlanoBeneficios) => (
                    <Select.Option key={e.serie} value={e.nome}>
                      {e.nome}
                    </Select.Option>
                  ))}
                </Select>

              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24} hidden={pessoaJuridicaRequisicao !== undefined}>
              <Form.Item
                label="CNPJ"
                name='cnpjNumeroAutConvenio'
              >
                <Input maxLength={18}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cnpjNumero: maskCnpj(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24} hidden={pessoaJuridicaRequisicao !== undefined}>
              <Form.Item
                label="Número de Identificação Fiscal (NIF)"
                name='numeroIdentificacaoFiscalAutConvenio'
              >
                <Input
                  maxLength={21}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5} hidden={pessoaJuridicaRequisicao !== undefined}>
              <Tooltip title='Pesquisar Pessoa Jurídica'>
                <Button
                  shape='round' type='primary' icon={<SearchOutlined />}
                  style={{ marginTop: "30px", marginLeft: "3px" }}
                  onClick={() => {
                    getPessoaJuridica();
                  }} >
                  Pesquisar Pessoa Jurídica
                </Button>
              </Tooltip>
            </Col>

            <Col xs={24} xl={12} hidden={pessoaJuridicaRequisicao === undefined}>
              <Form.Item
                label="Nome Empresarial"
                name='razaoSocialPessoaJuridicaConvenio'
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="Anulação de Operação"
        open={modalAnulacaoAberto}
        onOk={() => {
          if (efpcRequerente?.numero) {

            if (operacaoSelecionada?.tipoInterface === tpAlteracaoEfpc)
              setTipoAcao(218)
            else if (operacaoSelecionada?.tipoInterface === tpAutorizacaoPlano)
              setTipoAcao(209)
            else if (operacaoSelecionada?.tipoInterface === tpAlteracaoPlano)
              setTipoAcao(219)

            setTipoAcao(109);
            setModalAnulacaoAberto(false);
          }
          else
            errorMessage("Número (CNPJ, NIF, Processo) da Pessoa Jurídica não localizada.");

        }}
        onCancel={() => setModalAnulacaoAberto(false)}
      >
        <Form layout="vertical" form={form}>
          <p>Requisitante: {efpcRequerente?.sigla} </p>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <Form.Item
                label="Justificativa para a Anulação"
                name="justificativaAnulacao"
                rules={[
                  {
                    required: true,
                    message: "Informe a justificativa",
                  },
                ]}
              >
                <TextArea />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Form layout="vertical" form={form} onFinish={identificarAcao}>
        <div className="main-content pl-sm-3 mt-4">
          <h1>Operações por Entidade</h1>
        </div>

        <div className="main-content pl-sm-3 mt-4">
          <h2>Informações do Requerente</h2>
        </div>

        <Row>
          <Col xs={24} xl={6} hidden={pessoaJuridicaefpcRequerente?.tipoIdentificador != 1} >
            <Form.Item
              label="CNPJ do Entidade"
              name="operacaoCnpjEfpc">
              <PatternFormat
                disabled
                customInput={Input}
                format="##.###.###/####-##"
              />
            </Form.Item>
          </Col>

          <Col xs={24} xl={6} hidden={pessoaJuridicaefpcRequerente?.tipoIdentificador != 3} >
            <Form.Item
              label="Número de Processo da Entidade"
              name="operacaoNumeroProcessoEfpc">
              <PatternFormat
                disabled
                customInput={Input}
                format={efpcRequerente?.numero.at.length === 17 ? "#####.######/####-##" : efpcRequerente?.numero.at.length === 15 ? "#####.######/##-##" : "##########"}
              />
            </Form.Item>
          </Col>

          <Col xs={24} xl={12}>
            <Form.Item label="Razão Social"
              name="operacaoRazaoSocial">
              <Input disabled={true} />
            </Form.Item>
          </Col>

          <Col xs={24} xl={6}>
            <Form.Item label="Sigla"
              name="operacaoSigla">
              <Input disabled={true} />
            </Form.Item>
          </Col>
        </Row>

        <div className="main-content pl-sm-3 mt-4">
          <h2>Novas Operações</h2>
        </div>



        <Flex gap="small" align="flex-start" vertical>
          <Flex gap="small" wrap>
            <Row>
              <Space align="start">
                <Button shape='round'
                  icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
                      errorMessage("Não foi possível abrir a tela de cadastro da Operação. Serie da Entidade não identificada.")
                    } else {
                      setModalNovaRequisicaoAlteracaoEfpcAberto(true);
                    }
                  }} >
                  Alteração de Entidade
                </Button>
              </Space>
            </Row>
          </Flex>

          <Flex gap="small" wrap>
            <Row>
              <Space align="start">
                <Button shape='round'
                  icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    pushToNovaOperacaoAutorizarPlano();
                  }} >
                  Autorização de Plano de Benefícios
                </Button>

                <Button shape='round'
                  icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
                      errorMessage("Não foi possível abrir a tela de cadastro da Operação. Serie da Entidade não identificada.")
                    } else {
                      setTipoRequisicao(3);
                      getPlanosPorPorSerieEfpc(efpcRequerente.numero);
                    }
                  }} >
                  Alteração de Planos de Benefícios
                </Button>
              </Space>
            </Row>
          </Flex>

          <Flex gap="small" wrap>
            <Row>
              <Space align="start">
                <Button shape='round'
                  icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    if (!efpcRequerente || !efpcRequerente.serie || efpcRequerente.serie <= 0) {
                      errorMessage("Não foi possível abrir a tela de cadastro da Operação. Serie da Entidade não identificada.")
                    } else {
                      setTipoRequisicao(4);
                      getPlanosPorPorSerieEfpc(efpcRequerente.numero);
                    }
                  }} >
                  Autorização de Convênio de Adesão
                </Button>
              </Space>
            </Row>
          </Flex>
        </Flex>

        <div className="main-content pl-sm-3 mt-4">
          <h2>Operações vinculadas à Entidade</h2>
        </div>
        <Table
          // className="overflowConsulta"
          rowSelection={operacaoRowSelection}
          dataSource={operacoesEfpc}
          size="middle"
          columns={columnsOperacoes}
          rowKey="id"
          loading={loading}
          scroll={{ x: "max-content", y: 350 }}
        />

        <PageHeader
          className='site-page-header'
          style={{ background: "#FFF" }}
          extra={
            <div
              style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
              }}
            >
              <Space align='center'>

                <Button shape='round'
                  disabled={!operacaoSelecionada || operacaoSelecionada.situacao !== 0 || !efpcRequerente}
                  type='primary' icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    if (operacaoSelecionada?.tipoInterface === tpAlteracaoEfpc) {
                      setTipoAcao(1);
                    } else if (operacaoSelecionada?.tipoInterface === tpAutorizacaoPlano) {
                      setTipoAcao(2);
                    } else if (operacaoSelecionada?.tipoInterface === tpAlteracaoPlano) {
                      setTipoAcao(3);
                    } else if (operacaoSelecionada?.tipoInterface === tpAutorizacaoConvenio) {
                      setTipoAcao(4);
                    }
                  }} >
                  Aprovar Operação
                </Button>

                <Button shape='round'
                  disabled={!operacaoSelecionada || operacaoSelecionada.situacao !== 0 || !efpcRequerente}
                  type='primary' icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    if (operacaoSelecionada?.tipoInterface === tpAlteracaoEfpc)
                      setTipoAcao(118)
                    else if (operacaoSelecionada?.tipoInterface === tpAutorizacaoPlano)
                      setTipoAcao(109)
                    else if (operacaoSelecionada?.tipoInterface === tpAlteracaoPlano)
                      setTipoAcao(119)
                  }} >
                  Cancelar Operação
                </Button>

                <Button shape='round'
                  disabled={!operacaoSelecionada || operacaoSelecionada.situacao !== 1 || !efpcRequerente}
                  type='primary' icon={<CheckOutlined />} htmlType='button'
                  onClick={() => {
                    setModalAnulacaoAberto(true);
                  }} >
                  Anular Operação
                </Button>


              </Space>
            </div>
          }
        />


      </Form>

    </Spin >
  );
};

export default Operacoes;
